module.exports = __webpack_public_path__ + "img/ic_pai_qi.1c829e10.png";